import React from "react";
import { Box, Typography } from "@mui/material";

export default function ReportsPage() {
  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Reports
      </Typography>
      <Typography>Coming soon: P&L, Balance Sheet, VAT reports.</Typography>
    </Box>
  );
}
